
import { env } from '@env';
import { HttpRequestData, httpUtil, PaginationResponse } from '@/framework';
import {  TypeRevenueOverview } from '@/shared/enum';

export interface GetRevenueOfObjectTypeTableRequest extends HttpRequestData {
    readonly query: {
        readonly salonId: number;
        readonly startDate: string;
        readonly endDate: string;
        readonly objectType?: TypeRevenueOverview;
    }
}

export interface GetRevenueOfObjectTypeTableResponse  {
    readonly totalRevenue?: number;
    readonly totalQuantity?: number;
    readonly discount?: number;
    readonly objectName?: string;
    readonly objectId?: number;
    readonly salonId?: number;
    readonly salonBranchId?: number;
}

export const getRevenueOfObjectTypeTable = httpUtil.createHttpRequestMeta<
    GetRevenueOfObjectTypeTableRequest,
    PaginationResponse<GetRevenueOfObjectTypeTableResponse>
>({
    baseUrl: env.orgServer,
    path: '/revenues/object-type',
    method: 'GET',
    authentication: 'bearer'
});
